<div class="modal-body container-fluid overflow-auto px-4">

  <div class="w-100 d-flex">
    <span class="title-div">Which solution approach do you prefer?</span>
  </div>

  <div class="w-100 d-flex flex-row gap-4">
    <div
      class="w-50 d-flex agent-tile"
      [class.selected]="selectedType === 'agentic'"
      (click)="selectType('agentic')"
      (keydown.enter)="selectType('agentic')"
      tabindex="0"
      role="button"
      [attr.aria-pressed]="selectedType === 'agentic'"
    >
      <div class="logo-image mt-3 mb-2">
        <img
          [src]="selectedType === 'agentic' ? 'assets/images/virtusa-icons/agentic-ai-purple.svg' : 'assets/images/virtusa-icons/agentic-ai-gray.svg'"
          alt="Agentic AI icon"
        />
      </div>
      <div class="w-100 d-flex flex-column logo-content mb-3 justify-content-center">
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <span class="header-9 master-title">Agentic AI Approach</span>
          <span class="beta-badge">
            Beta
            <img [src]="'images/virtusa-icons/diamond-outline.svg' | assetUrl" alt="Diamond outline icon" />
          </span>
        </div>
        <span class="general-text-2-1 desc mt-1"
          >Chat-driven experience for natural, conversational interactions and dynamic task handling</span
        >
      </div>
    </div>

    <div
      class="w-50 d-flex agent-tile"
      [class.selected]="selectedType === 'nonAgentic'"
      (click)="selectType('nonAgentic')" (keydown.enter)="selectType('nonAgentic')"
    >
      <div class="logo-image mt-3 mb-2">
        <img [src]="selectedType === 'nonAgentic' ? 'assets/images/virtusa-icons/non-agentic-purple.svg' : 'assets/images/virtusa-icons/non-agentic-gray.svg'" alt="logo" />
      </div>
      <div class="w-100 d-flex flex-column logo-content mb-3 justify-content-center">
        <span class="header-9 master-title">Non-agentic AI Approach</span>
        <span class="general-text-2-1 desc"
          >Ideal for guided, form-based automation and structured task execution</span
        >
      </div>
    </div>
  </div>

  <div
    class="w-100 d-flex flex-column align-items-center justify-content-center"
  >
    @if(selectedType === 'agentic' || selectedType === 'nonAgentic'){
    <span class="header-11 dark-text"> Help me choose</span>
    } @else {
    <span class="header-11"> Help me choose</span>
    }
    <div class="agentic-content mt-2">
      <div class="header-coverage">
        If you prefer a  <span class="header-coverage-bold">natural chat experience</span> where you can just ask and the AI figures it out, choose  <span class="header-coverage-bold">Agentic AI Approach</span>
      </div>
      <!-- <div class="header-coverage mg-top">
      </div> -->
    </div>
    <div class="agentic-content mt-2">
      <div class="header-coverage"> 
        If you like <span class="header-coverage-bold">guided steps and clear workflows</span>, go with <span class="header-coverage-bold">Non-agentic AI Approach</span>
      </div>
    </div>
      
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button
      class="btn btn-accello-primary-outlined mx-2"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      class="btn btn-accello-primary-light"
      (click)="confirm()"
      [disabled]="selectedType == null"
    >
      <span>Confirm</span>
    </button>
  </div>
</div>
